import styled from 'styled-components'

import { helpers } from 'styles'

export const Description = styled.p`
	font-size: ${helpers.font.size.small};
	border-bottom: 1px solid ${helpers.color.border};
	padding-bottom: 16px;
	margin-bottom: 0;
`
